    <app-titulo [modulo]="titulo" [mostrar]="true"></app-titulo>
    <div class="container">

    <div class="d-flex justify-content-left mt-4 py-1 " *ngIf="showlist">
       <div class="d-flex col-md-1 me-5">
      <p class="mt-1 me-3" style="color: #266090;"><b>Usuario: </b></p>
    </div>
    <div class="d-flex col-md-5 me-5 " style="margin-bottom: 15px">
          <select class="form-select" aria-label="Default select example" [(ngModel)]="this.idUsuario"
                  (change)="traerUsuarioById()">
            <option disabled value="0" class="color-gris">Elija el Usuario</option>
            <option *ngFor="let item of listUsuariosdepurada" value="{{ item.idUsuario }}">{{ item.nombreUsuario
              }}
            </option>
          </select>
    </div>
    </div>


    <div class="d-flex justify-content-left mt-2 py-1">
        <div class="d-flex col-md-5 me-5">
            <p class="mt-1 me-3" style="color: #266090;"><b>Nombre: </b>{{usuario.nombreUsuario}}</p>
        </div>
        <div class="d-flex col-md-5 ms-5">
            <p class="mt-1 me-3" style="color: #266090;"><b>Usuario: </b>{{usuario.email}}</p>
        </div>
    </div>
    <div class="d-flex justify-content-left mt-2 py-1">
        <div class="d-flex col-md-5 me-5">
            <p class="mt-1 me-3" style="color: #266090;"><b>Perfil: </b>{{usuario.perfil}}</p>
        </div>
        <div class="d-flex col-md-5 ms-5">
            <p class="mt-1 me-3" style="color: #266090;"><b>Área: </b>{{usuario.area}}</p>
        </div>
    </div>
    <div class="d-flex justify-content-left mt-4">
        <div class="d-flex col-md-5 mt-2 me-5">
            <label class="azul-titulos fw-bold">{{ subtitulo1 }}</label>
        </div>
        <div class="d-flex col-md-5 mt-2 ms-5">
            <label class="azul-titulos fw-bold">{{ subtitulo2 }}</label>
        </div>
    </div>
    <div class="d-flex justify-content-left mt-4">
        <div class="card col-md-5 mt-1 me-5 scroll-listas">
            <ul class="list-group col-md-12">
                <li class="list-group-item cursor" *ngFor="let item of listAplicativos"
                    value="{{ item.idAplicativo }}"
                    [ngClass]="{'active': indice == item.idAplicativo}"
                    (click)="cargarRoles(item.idAplicativo!)">
                    {{ item.nombreAplicativo }}
                </li>
            </ul>
        </div>
        <div class="card col-md-5 mt-1 ms-5 scroll-listas">
            <ul class="list-group col-md-12">
                <li class="list-group-item" *ngFor="let item of listRoles">{{ item }}</li>
            </ul>
        </div>
    </div>
    <div class="d-flex justify-content-left mt-4">
        <div class="d-flex justify-content-end col-md-7">
            <div class="me-4">
                <button class="btn btn-primary" *ngIf="idUsuario != undefined" (click)="regresar()">REGRESAR</button>
            </div>
        </div>
    </div>
    </div>
